<h3>Client Flagged Providers</h3>

<form [formGroup]="formGroup" novalidate>
  <div class="container-fluid p-2 border bg-light mb-2">
    <div class="row">
      <div class="col-2 pe-1">
        <div class="mb-3" formGroupName="filters">
          <label>
            Status:
          </label>
          <ng-select
            class="w-100"
            name="status"
            bindValue="value"
            bindLabel="display"
            [multiple]="true"
            [items]="filterOptions"
            [clearable]="true"
            [searchable]="false"
            placeholder="Filter by Status"
            formControlName="status" />
        </div>
      </div>

      <div class="col-2 pe-1">
        <div class="mb-3">
          <label>
            Sort By:
          </label>
          <ng-select
            class="w-100"
            name="sortBy"
            bindValue="value"
            bindLabel="display"
            [multiple]="false"
            [items]="sortByOptions"
            [clearable]="false"
            [searchable]="false"
            formControlName="sort" />
        </div>
      </div>
    </div>
  </div>
</form>

@if (!loading) {
  <div>
    @if (prescriberIncorrectInformationRequests.length > 0) {
      <section>
        <app-pagination-header
          [label]="'client flagged providers'"
          [paging]="paging"
          (pageSizeChange)="onPageSizeChange($event)"
          />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>CLIENT</th>
              <th>USER</th>
              <th>PRESCRIBER</th>
              <th>SPECIALTIES</th>
              <th>COMMENTS</th>
              <th>STATUS</th>
              <th>DATE REPORTED</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (request of prescriberIncorrectInformationRequests; track request; let i = $index) {
              <tr>
                <td>{{ request.client.humanizedName }}</td>
                <td>{{ request.submittedBy.fullName }}</td>
                <td><app-prescriber-name [provider]="request.provider" [linkToProvider]="true" /></td>
                <td>{{ request.provider.displaySpecialty }}</td>
                <td>{{ request.comments }}</td>
                <td>
                  @if (request.resolvedAt) {
                    <span>
                      Resolved ({{ request.resolvedBy.email }})
                    </span>
                  }
                  @if (!request.resolvedAt) {
                    <span>
                      Needs Review
                    </span>
                  }
                </td>
                <td>{{ request.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
                <td>
                  <ul class="nav">
                    <li class="nav-item">
                      @if (!request.resolvedAt) {
                        <a href="#" (click)="resolve($event, request)">
                          Resolve
                        </a>
                      }
                      @if (request.resolvedAt) {
                        <a href="#" (click)="unresolve($event, request)">
                          Cancel
                        </a>
                      }
                    </li>
                  </ul>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </section>
    } @else {
      <section><p>There are no client flagged providers.</p></section>
    }
  </div>
} @else {
  <mat-spinner />
}
